/*
 * partner-stores.js — чипы городов и карта страницы «Магазины партнёров»
 * (sections/ds-partner-stores.liquid).
 *
 * Чипы: одиночный выбор (aria-pressed), скрывают группы сетки чужих городов
 * и просят карту приблизить точки выбранного города.
 *
 * Карта: Leaflet из assets (адреса в data-атрибутах контейнера) грузится
 * лениво — когда контейнер подходит к экрану на 200px. До этого страница
 * не тянет ни скрипт, ни тайлы. Данные точек — JSON в <script> рядом с картой.
 *
 * Карточка точки у карты отрендерена сервером флагманом; здесь — подмена
 * содержимого по клику на маркер, подсветка маркера, возврат к флагману по
 * чипу «Все» и подсказка при выборе города. Leaflet-попапы — только если
 * секция без карточки.
 *
 * Инициализация идемпотентна (data-partner-ready), Theme Editor перерисовывает
 * секцию целиком — слушаем shopify:section:load.
 */

(function () {
  if (window.dsPartnerStores) return;
  window.dsPartnerStores = true;

  var leafletPromise = null;

  function loadLeaflet(jsUrl, cssUrl) {
    if (window.L) return Promise.resolve(window.L);
    if (leafletPromise) return leafletPromise;
    leafletPromise = new Promise(function (resolve, reject) {
      if (cssUrl && !document.querySelector('link[data-leaflet-css]')) {
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = cssUrl;
        link.setAttribute('data-leaflet-css', '');
        document.head.appendChild(link);
      }
      var script = document.createElement('script');
      script.src = jsUrl;
      script.defer = true;
      script.onload = function () { resolve(window.L); };
      script.onerror = function () { leafletPromise = null; reject(new Error('leaflet')); };
      document.head.appendChild(script);
    });
    return leafletPromise;
  }

  function parseData(root) {
    var node = root.querySelector('[data-partner-data]');
    if (!node) return null;
    try {
      var data = JSON.parse(node.textContent);
      data.stores = (data.stores || []).map(function (s) {
        return { city: s.city, name: s.name, address: s.address, text: s.text || '', maps: s.maps || '', instagram: s.instagram || '', lat: parseFloat(s.lat), lng: parseFloat(s.lng) };
      }).filter(function (s) { return !isNaN(s.lat) && !isNaN(s.lng); });
      if (data.flagship) {
        data.flagship.lat = parseFloat(data.flagship.lat);
        data.flagship.lng = parseFloat(data.flagship.lng);
        if (isNaN(data.flagship.lat) || isNaN(data.flagship.lng)) data.flagship = null;
      }
      return data;
    } catch (e) {
      return null;
    }
  }

  function escapeHtml(text) {
    return String(text || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function initRoot(root) {
    if (root.hasAttribute('data-partner-ready')) return;
    root.setAttribute('data-partner-ready', '');

    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-partner-city]'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-partner-group]'));
    var mapEl = root.querySelector('[data-partner-map]');
    var data = mapEl ? parseData(root) : null;
    var map = null;
    var flagshipMarker = null;
    var activeCity = '';
    var selected = null;

    /* Карточка точки: десктоп — слева от карты, мобайл — под ней. */
    var detail = root.querySelector('[data-partner-detail]');
    var desktop = window.matchMedia('(min-width: 990px)');
    var detailEl = {
      empty: detail && detail.querySelector('[data-partner-detail-empty]'),
      card: detail && detail.querySelector('[data-partner-detail-card]'),
      city: detail && detail.querySelector('[data-partner-detail-city]'),
      name: detail && detail.querySelector('[data-partner-detail-name]'),
      address: detail && detail.querySelector('[data-partner-detail-address]'),
      text: detail && detail.querySelector('[data-partner-detail-text]'),
      maps: detail && detail.querySelector('[data-partner-detail-maps]'),
      instagram: detail && detail.querySelector('[data-partner-detail-instagram]'),
      page: detail && detail.querySelector('[data-partner-detail-page]')
    };

    var storeStyle = { radius: 9, color: '#3b2416', weight: 2, fillColor: '#bf8f24', fillOpacity: 0.95 };
    var storeSelectedStyle = { radius: 11, color: '#fffdf9', weight: 2, fillColor: '#3b2416', fillOpacity: 1 };
    var flagshipStyle = { radius: 11, color: '#fffdf9', weight: 2, fillColor: '#3b2416', fillOpacity: 1 };
    var flagshipSelectedStyle = { radius: 13, color: '#bf8f24', weight: 3, fillColor: '#3b2416', fillOpacity: 1 };

    function setLink(el, href) {
      if (!el) return;
      if (href) { el.href = href; el.hidden = false; } else { el.hidden = true; }
    }

    function setText(el, value) {
      if (!el) return;
      el.textContent = value || '';
      el.hidden = !value;
    }

    function unselectMarker() {
      if (selected && selected.marker) selected.marker.setStyle(selected.flagship ? flagshipStyle : storeStyle);
      selected = null;
    }

    /* Подсказка «нажмите на точку» — после выбора города, пока маркер не выбран. */
    function showPlaceholder() {
      unselectMarker();
      if (!detail) return;
      detailEl.card.hidden = true;
      detailEl.empty.hidden = false;
    }

    /* marker может быть null — флагман по умолчанию до загрузки карты. */
    function showDetail(item, marker, isFlagship) {
      unselectMarker();
      if (marker) {
        marker.setStyle(isFlagship ? flagshipSelectedStyle : storeSelectedStyle);
        marker.bringToFront();
        selected = { marker: marker, flagship: isFlagship };
      }
      if (!detail) return;
      setText(detailEl.city, item.city);
      detailEl.name.textContent = item.name || '';
      detailEl.address.textContent = item.address || '';
      setText(detailEl.text, item.text);
      setLink(detailEl.maps, item.maps);
      setLink(detailEl.instagram, isFlagship ? '' : item.instagram);
      setLink(detailEl.page, isFlagship ? item.page : '');
      detailEl.empty.hidden = true;
      detailEl.card.hidden = false;
    }

    function showFlagship() {
      if (data && data.flagship) showDetail(data.flagship, flagshipMarker, true);
      else showPlaceholder();
    }

    /* Клик по маркеру: карточка под картой на мобайле может быть за
       экраном — подтягиваем её в зону видимости. */
    function onMarkerPick(item, marker, isFlagship) {
      showDetail(item, marker, isFlagship);
      if (detail && !desktop.matches && detail.scrollIntoView) {
        detail.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    }

    function fitTo(city) {
      if (!map || !window.L || !data) return;
      var points = data.stores.filter(function (s) { return !city || s.city === city; })
        .map(function (s) { return [s.lat, s.lng]; });
      if (!city && data.flagship) points.push([data.flagship.lat, data.flagship.lng]);
      if (!points.length) return;
      map.fitBounds(window.L.latLngBounds(points), { padding: [40, 40], maxZoom: 15 });
    }

    function pick(city) {
      activeCity = city;
      if (city) showPlaceholder(); else showFlagship();
      chips.forEach(function (chip) {
        chip.setAttribute('aria-pressed', chip.getAttribute('data-partner-city') === city ? 'true' : 'false');
      });
      groups.forEach(function (group) {
        group.hidden = !!city && group.getAttribute('data-partner-group') !== city;
      });
      fitTo(city);
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        pick(chip.getAttribute('data-partner-city') || '');
      });
    });

    function buildMap(L) {
      if (map || !mapEl || !data) return;
      map = L.map(mapEl, { scrollWheelZoom: false });
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a>',
        maxZoom: 18
      }).addTo(map);

      /* Попапы — только если секция без карточки точки. */
      var usePopups = !detail;

      data.stores.forEach(function (s) {
        var marker = L.circleMarker([s.lat, s.lng], storeStyle).addTo(map);
        if (usePopups) marker.bindPopup('<strong>' + escapeHtml(s.name) + '</strong><br>' + escapeHtml(s.address) + ', ' + escapeHtml(s.city));
        marker.on('click', function () { onMarkerPick(s, marker, false); });
      });
      if (data.flagship) {
        flagshipMarker = L.circleMarker([data.flagship.lat, data.flagship.lng], flagshipStyle).addTo(map);
        if (usePopups) flagshipMarker.bindPopup('<strong>' + escapeHtml(data.flagship.name) + '</strong><br>' + escapeHtml(data.flagship.address));
        flagshipMarker.on('click', function () { onMarkerPick(data.flagship, flagshipMarker, true); });
      }
      fitTo(activeCity);
      /* Карточка уже показывает флагман (серверный рендер) — подсветить его
         маркер. Только после fitTo: до первого setView у векторных слоёв нет
         рендерера и bringToFront падает. */
      if (flagshipMarker && !activeCity && !selected) showDetail(data.flagship, flagshipMarker, true);
    }

    if (mapEl && data) {
      var start = function () {
        loadLeaflet(mapEl.getAttribute('data-leaflet-js'), mapEl.getAttribute('data-leaflet-css'))
          .then(buildMap)
          .catch(function () { mapEl.hidden = true; });
      };
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          if (entries.some(function (entry) { return entry.isIntersecting; })) {
            observer.disconnect();
            start();
          }
        }, { rootMargin: '200px 0px' });
        observer.observe(mapEl);
      } else {
        start();
      }
    }
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-partner-stores]'), initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
